import {useContext, useEffect} from "react";
import {NavigationContext} from "../common/NavigationContext";

export default function useOnClickOrFocusOutside(ref, listening, handler) {
    const {isReactDialogOpen} = useContext(NavigationContext);
    useEffect(() => {
        const listener = (event) => {
            // if clicking or focusing inside the ref, ignore
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };

        if (listening && !isReactDialogOpen) {
            document.addEventListener("mouseup", listener);
            document.addEventListener("touchend", listener);
            document.addEventListener("focusin", listener);  // handle tab/focus changes
        }

        return () => {
            document.removeEventListener("mouseup", listener);
            document.removeEventListener("touchend", listener);
            document.removeEventListener("focusin", listener);
        };
    }, [ref, handler, listening, isReactDialogOpen]);
}
